var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.888,
    height: 24.228,
    viewBox: "0 0 33.888 24.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1198",
    "data-name": "Groupe 1198",
    transform: "translate(-1784 -46.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2777",
    "data-name": "Trac\\xE9 2777",
    d: "M1.639,3.105,32.439,3a1.5,1.5,0,0,0,0-3L1.639.1a1.5,1.5,0,0,0,0,3",
    transform: "translate(1784 46.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2778",
    "data-name": "Trac\\xE9 2778",
    d: "M1.447,11.289c10.33-.343,20.661.212,30.991,0,1.928-.04,1.935-3.04,0-3-10.33.212-20.661-.343-30.991,0-1.925.064-1.934,3.064,0,3",
    transform: "translate(1784 48.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2779",
    "data-name": "Trac\\xE9 2779",
    d: "M1.637,19.791c9.806.359,19.62.228,29.43.437,1.932.042,1.931-2.958,0-3-9.81-.209-19.624-.078-29.43-.437-1.931-.071-1.928,2.929,0,3",
    transform: "translate(1784 50.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsMenu);
export default __webpack_public_path__ + "static/media/bars_menu.dfdeb9effe00687d1880ede1e4a70706.svg";
export { ForwardRef as ReactComponent };